<template>
    <p class="from">
        <span>{{source}}</span>
        <span>{{createTime | releaseTime}}</span>
    </p>
</template>

<script>
export default {
    name: "from",
    props: {
        source: String,
        createTime: Number
    },
    filters: {
        releaseTime(createTime){ 
            let getTime = new Date().getTime();           
            let minute = 1000 * 60;
            let hour = minute * 60;
            let day = hour * 24;
            let difference = getTime - createTime;
            let setMin = parseInt(difference / minute);
            let setHour = parseInt(difference / hour);
            let setDay = parseInt(difference / day); 
            let result = '';
            if(difference < 0){
                result = '刚刚';    
            }
            if(setMin >= 1){
                result = `${setMin}分钟前`;
            }
            if(setHour >= 1){
                result = `${setHour}小时前`;
            }
            if(setDay >= 1){
                result = `${setDay}天前`;
            }
            if(setDay >= 30){
                let beforeDate = new Date(createTime);
                let year = beforeDate.getFullYear();
                let beforeMonth = beforeDate.getMonth() + 1;
                let beforeDay = beforeDate.getDate(); 
                result = `${year} - ${beforeMonth} - ${beforeDay}`;
            }
            return result
        }
    }
}
</script>

<style scoped>
.from {
    color: #999;
    font-size: 0.35rem;
    font-family: "Microsoft YaHei", SimSun
}
.from span{
    margin-right: 0.2rem;
}
</style>
